<template>

    <div class="rendezvous-grid">
        <div class="grid-item">
            <LoadingSpinner></LoadingSpinner>
        </div>
    </div>

</template>

<script>

    import LoadingSpinner from "atoms/LoadingSpinner"

    export default {
        name: 'TVERendezvousSpinner',
        components: { LoadingSpinner },
        computed: {},
        methods: {},
        watch: {}
    }
</script>
